import { useAuth } from '@ophelos/ui/contexts/workos-auth-context';
import { useQuery } from '@tanstack/react-query';
import { currentUserQueryKey, fetchCurrentUser } from '@/hooks/currentUserQuery';

export interface CurrentUser {
  id: string;
  first_name: string | null;
  last_name: string | null;
  email: string;
  avatar_url: string | null;
  avatar_color: string | null;
}

export function useCurrentUser() {
  const { user: authUser } = useAuth();

  const query = useQuery({
    queryKey: currentUserQueryKey(authUser?.id),
    queryFn: fetchCurrentUser,
    enabled: !!authUser?.id,
    staleTime: 5 * 60 * 1000,
  });

  return { user: query.data ?? null, isLoading: query.isLoading };
}
